export default "__VITE_ASSET__536bba2d__"